  /* eslint-disable array-callback-return */
  /* eslint-disable react-hooks/exhaustive-deps */
  import {
    setBackButtonPath,
  // TOAST_MESSAGE_SEVERITY_ERROR,
  setPageTitle,
  showToast,
  TOAST_MESSAGE_SEVERITY_SUCCESS,
} from '../layout/layout.actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, makeStyles, MenuItem, TextField, Typography } from '@material-ui/core';
import GooglePlacesAutocompleteComponent from 'common/form/googlePlacesAutocomplete.component';
import BenefitSelections from './benefitSelections.component';
import { getDistance } from 'utilities/googleMapsClient';
import { GET_ESTIMATES_SUCCESS, getAutoShipmentCost, getEstimates, getFlightPrice, getHomesalePriceByRegion, postEstimate, setEstimations, updateEstimate } from './estimator.actions';
import { COUNTRY_CODES } from 'utilities/countryCodes';
import { getGsaPerDiem, getNationalGsaLodgingPerDiem, getNationalGsaMealPerDiem } from './estimatorDataRequests';
import { getBenefits } from './constants';
import { getSelectedClientInformation } from 'utilities/authUtils';
import { setBaseMoveInfo } from 'modules/transferees/transferees.actions';
import Hint from 'common/hint.component';
import NavigationPrompt from 'react-router-navigation-prompt';
import ConfirmModal from 'common/confirmModal.component';
import { getTotalEstimateAmount } from './utils';

const useStyles = makeStyles((theme) => ({
  textField: {
     maxWidth: '200px',
  },
}));

const CostEstimatorPage = (props) => {  
  const estimateId = props.match.params.estimateId ? parseInt(props.match.params.estimateId) : null;
  const estimateInfo = estimateId ? props.estimates.find((e) => e.estimateId === estimateId) : null;

  const [costEstimatePolicyId, setCostEstimatePolicyId] = useState(estimateInfo ? estimateInfo.costEstimatePolicyId : null);
  const [reloPolicy, setReloPolicy] = useState(estimateInfo ? estimateInfo.reloPolicy : null);
  const [hasSpouse] = useState(estimateInfo ? estimateInfo.hasSpouse : false);
  const [accompanyingAdults, setAccompanyingAdults] = useState(estimateInfo ? estimateInfo.accompanyingAdults : 0);
  const [origin, setOrigin] = useState(estimateInfo ? estimateInfo.origin : '');
  const [destination, setDestination] = useState(estimateInfo ? estimateInfo.destination : '');
  const [transfereeName, setTransfereeName] = useState(estimateInfo ? estimateInfo.transfereeName : null);
  const [distance, setDistance] = useState(0);
  const [isExecutive] = useState(estimateInfo ? estimateInfo.isExecutive : false);

  const [needsDisclaimer, setNeedsDisclaimer] = useState(localStorage.getItem('disclaimer') ? false : true);

  const [benefits, setBenefits] = useState([]);

  const [perDiemRate, setPerDiemRate] = useState(0);
  const [perDiemMealRate, setPerDiemMealRate] = useState(0);
  const [avgHomesalePrice, setAvgHomesalePrice] = useState(0);
  const [avgHomesalePriceOrigin, setAvgHomesalePriceOrigin] = useState(0);
  const [flightCost, setFlightCost] = useState(0);
  const [isUpdatingSelections, setIsUpdatingSelections] = useState(false);
  const [homefindingDays, setHomefindingDays] = useState(3);
  const [autoShipmentCost, setAutoShipmentCost] = useState(0);

  const [savingEstimate, setSavingEstimate] = useState(false);

  const [isDirty, setIsDirty] = useState(false);
  const [isBenefitListDirty, setIsBenefitListDirty] = useState(false);

  const [updatedPolicyBenefits, setUpdatedPolicyBenefits] = useState(null);
  const [updatedGrossUp, setUpdatedGrossUp] = useState(false);

  const clientId = getSelectedClientInformation().id;

  const classes = useStyles();

  const saveEstimate = async (savedBenefits, applyTaxGrossUp, grossUpPercentage, isSettingPolicyOrOwnershipType, topLevelInputOneId, topLevelInputTwoId, topLevelInputThreeId, topLevelInputFourId, topLevelInputFive, topLevelInputSix, topLevelInputSeven, topLevelInputEight, topLevelInputNine) => {
      setSavingEstimate(true);

      let today = new Date();
      today.setDate(today.getDate() + 1);

      let estimateBody = {
          estimateId: estimateId,
          clientId: clientId,
          costEstimatePolicyId: costEstimatePolicyId,
          reloPolicy: reloPolicy,
          hasSpouse: hasSpouse,
          accompanyingAdults: accompanyingAdults,
          origin: typeof origin === 'string' ? null : origin,
          destination: typeof destination === 'string' ? null : destination,
          transfereeName: transfereeName,
          distance: distance,
          isExecutive: isExecutive,
          topLevelInputOneId: topLevelInputOneId ? topLevelInputOneId : (estimateInfo ? estimateInfo.topLevelInputOneId : null),
          topLevelInputTwoId: topLevelInputTwoId ? topLevelInputTwoId : (estimateInfo ? estimateInfo.topLevelInputTwoId : null),
          topLevelInputThreeId: topLevelInputThreeId ? topLevelInputThreeId : (estimateInfo ? estimateInfo.topLevelInputThreeId : null),
          topLevelInputFourId: topLevelInputFourId ? topLevelInputFourId : (estimateInfo ? estimateInfo.topLevelInputFourId : null),
          topLevelInputFive: topLevelInputFive ? topLevelInputFive : (estimateInfo ? estimateInfo.topLevelInputFive : null),
          topLevelInputSix: topLevelInputSix ? topLevelInputSix : (estimateInfo ? estimateInfo.topLevelInputSix : null),
          topLevelInputSeven: topLevelInputSeven? topLevelInputSeven : (estimateInfo ? estimateInfo.topLevelInputSeven : null),
          topLevelInputEight: topLevelInputEight ? topLevelInputEight : (estimateInfo ? estimateInfo.topLevelInputEight : null),
          topLevelInputNine: topLevelInputNine ? topLevelInputNine : (estimateInfo ? estimateInfo.topLevelInputNine : null),
          created: estimateInfo ? estimateInfo.created : null,
          modified: today,
          savedBenefits: savedBenefits,
          applyTaxGrossUp: applyTaxGrossUp !== undefined ? applyTaxGrossUp : (estimateInfo ? estimateInfo.applyTaxGrossUp : null),
          grossUpPercentage: grossUpPercentage ? grossUpPercentage : (estimateInfo ? estimateInfo.grossUpPercentage : 60)
      }

      const updateEstimateResp = await props.updateEstimate(estimateBody);
      if (updateEstimateResp.response) {
          const getEstimateResp = await props.getEstimates();
          if (getEstimateResp.type === GET_ESTIMATES_SUCCESS) {
              setBenefits(getBenefits(perDiemRate, perDiemMealRate, avgHomesalePrice, avgHomesalePriceOrigin, flightCost, homefindingDays, autoShipmentCost, distance));

              // Always update benefits from backend to sync local state after save
              const updatedEstimate = getEstimateResp.response.find((e) => e.estimateId === estimateId);
              const savedBenefitsFromBackend = updatedEstimate.savedBenefits;
              const cleanedBenefits = savedBenefitsFromBackend.map(benefit => {
                if (benefit.benefitNumber === 9 && benefit.options) {
                  // Deduplicate options for Additional Benefits
                  const deduplicatedOptions = benefit.options.filter((opt, index, self) => 
                    index === self.findIndex(o => o.optionNumber === opt.optionNumber)
                  );
                  return { ...benefit, options: deduplicatedOptions };
                }
                return benefit;
              });

              // Always update gross up from backend to ensure UI stays in sync
              setUpdatedGrossUp(updatedEstimate.applyTaxGrossUp);
              
              // Always update to ensure dirty checker works correctly after save
              setUpdatedPolicyBenefits(cleanedBenefits);

              props.showToast(`Successfully saved estimate ${estimateId}.`, { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
          }
      }

      setSavingEstimate(false);
  }

  const exportEstimate = (savedBenefits, applyTaxGrossUp, grossUpPercentage, topLevelInputOneId, topLevelInputTwoId, topLevelInputThreeId, topLevelInputFourId, topLevelInputFive, topLevelInputSix, topLevelInputSeven, topLevelInputEight, topLevelInputNine) => {
    if (!lastDayHasPassed) {
      saveEstimate(savedBenefits, applyTaxGrossUp, grossUpPercentage, false, topLevelInputOneId, topLevelInputTwoId, topLevelInputThreeId, topLevelInputFourId, topLevelInputFive, topLevelInputSix, topLevelInputSeven, topLevelInputEight, topLevelInputNine);
    }

    props.history.push(`/estimates/${props.match.params.estimateId}/export`);
  }

  const generateAuth = (benefits, savedBenefits, topLevelInputFive, topLevelInputSix, topLevelInputSeven, topLevelInputEight, topLevelInputNine, applyTaxGrossUp, getOptionCost, grossUpPercentage) => {
      let total = getTotalEstimateAmount(benefits, savedBenefits, topLevelInputFive, topLevelInputSix, topLevelInputSeven, topLevelInputEight, topLevelInputNine, avgHomesalePrice, avgHomesalePriceOrigin, applyTaxGrossUp, getOptionCost, grossUpPercentage);

      props.setBaseMoveInfo({
        FirstName: transfereeName.split(' ')[0],
        LastName: transfereeName.split(' ')[1],
        OldState: origin.state,
        OldCity: origin.city,
        OldCountry: COUNTRY_CODES.find((cc) => cc['alpha-2'] === origin.country)['alpha-3'],
        NewState: destination.state,
        NewCity: destination.city,
        NewCountry: COUNTRY_CODES.find((cc) => cc['alpha-2'] === destination.country)['alpha-3'],
        Ownership: reloPolicy,
        EstimateId: estimateId,
        EstimateTotal: total,
      });

      props.history.push('/authorizations/new');

    //   props.history.push(`/authorizations/new?firstName=${transfereeName.split(' ')[0]}&lastName=${transfereeName.split(' ')[1]}&oldCountry=${COUNTRY_CODES.find((cc) => cc['alpha-2'] === origin.country)['alpha-3']}&oldState=${origin.state}&oldCity=${origin.city}
    //       &newCountry=${COUNTRY_CODES.find((cc) => cc['alpha-2'] === destination.country)['alpha-3']}&newState=${destination.state}&newCity=${destination.city}&ownership=${reloPolicy}&estimateId=${estimateId}&estimateTotal=${total}`);
  }

  const changePolicy = (newPolicyId) => {
    let newPolicyInfo = (newPolicyId && props.policies) ? props.policies.find((p) => p.policyId === newPolicyId) : null;

    const staticBenefits = getBenefits(perDiemRate, perDiemMealRate, avgHomesalePrice, avgHomesalePriceOrigin, flightCost, homefindingDays, autoShipmentCost, distance);

    let newBenefits = [];
    newPolicyInfo && newPolicyInfo.savedBenefits && newPolicyInfo.savedBenefits.map((sb) => {
        let newBenefit = staticBenefits.find((b) => b.benefitNumber === sb.benefitNumber);
        if (newBenefit) {
            newBenefits.push({
                benefitNumber: newBenefit.benefitNumber,
                estimateId: estimateId,
                cost: sb.cost,
                isTaxable: sb.isTaxable,
                customLineCost: sb.customLineCost,
                customLineChecked: sb.customLineChecked,
                customLineDescription: sb.customLineDescription,
                options: newBenefit.options.map((opt) => {
                    let newOption = sb.options.find((so) => so.optionNumber === opt.optionNumber);
                    if (newOption) {
                        return {
                            optionNumber: opt.optionNumber,
                            selectionId: newOption ? newOption.selectionId : null,
                            customCost: newOption ? newOption.customCost : null,
                            customDescription: newOption ? newOption.customDescription : null,
                        };
                    }
                }).filter(Boolean),
            });
        }
    });

    saveEstimate(
        newBenefits, 
        newPolicyInfo ? newPolicyInfo.applyTaxGrossUp : null, 
        newPolicyInfo ? newPolicyInfo.grossUpPercentage : 60,
        true, 
        newPolicyInfo ? newPolicyInfo.topLevelInputOneId : null,
        newPolicyInfo ? newPolicyInfo.topLevelInputTwoId : null,
        newPolicyInfo ? newPolicyInfo.topLevelInputThreeId : null,
        newPolicyInfo ? newPolicyInfo.topLevelInputFourId : null,
        newPolicyInfo ? newPolicyInfo.topLevelInputFive : null,
        newPolicyInfo ? newPolicyInfo.topLevelInputSix : null,
        newPolicyInfo ? newPolicyInfo.topLevelInputSeven : null,
        newPolicyInfo ? newPolicyInfo.topLevelInputEight : null,
        newPolicyInfo ? newPolicyInfo.topLevelInputNine : null
    );

    setCostEstimatePolicyId(newPolicyId);
  }

  const changeOwnershipType = (newOwnershipType) => {
    let currentSavedBenefits = estimateInfo ? [...estimateInfo.savedBenefits] : [];

    if (newOwnershipType === 'Renter') {
        currentSavedBenefits = currentSavedBenefits.filter((sb) => sb.benefitNumber !== 4 && sb.benefitNumber !== 5);
    } else {
        currentSavedBenefits = currentSavedBenefits.filter((sb) => sb.benefitNumber !== 1);
    }

    setReloPolicy(newOwnershipType);

    setUpdatedPolicyBenefits(currentSavedBenefits);
  }

  const checkIsDirty = () => {
      if (estimateInfo) {
          let accompanyingAdultsComp = accompanyingAdults ? parseInt(accompanyingAdults) : 0;
          if (costEstimatePolicyId !== estimateInfo.costEstimatePolicyId || reloPolicy !== estimateInfo.reloPolicy 
              || accompanyingAdultsComp !== estimateInfo.accompanyingAdults || (origin?.city !== estimateInfo.origin?.city && estimateInfo.origin) || destination?.city !== estimateInfo.destination?.city || transfereeName !== estimateInfo.transfereeName) {
              setIsDirty(true);
          } else {
              setIsDirty(false);
          }
      }
  }

  useEffect(() => {
      (async () => {
          const perDiemSelectionId = estimateInfo?.savedBenefits ? estimateInfo.savedBenefits.find((sb) => sb.benefitNumber === 3)?.options.find((opt) => opt.optionNumber === 15)?.selectionId : null;
          const numDaysBetweenFlights = perDiemSelectionId ? (perDiemSelectionId === 8 ? 1 : (perDiemSelectionId === 9 ? 2 : (perDiemSelectionId === 11 ? 4 : 3))) : 3;
          setHomefindingDays(numDaysBetweenFlights);

          if (destination && destination.city && destination.state) {
              setIsUpdatingSelections(true);

              const gsaResp = await getGsaPerDiem(destination.city, destination.state, '2025');
              const gsaDestinationState = gsaResp.rates[0].state;
              let gsaDestinationCity = gsaResp.rates[0].rate[0].city;

              const gsaNationalLodgingRate = await getNationalGsaLodgingPerDiem();
              const gsaNationalMealRate = await getNationalGsaMealPerDiem();

              let regionName = 'United States';
              if (gsaDestinationCity !== null && gsaDestinationState !== null) {
                gsaDestinationCity = gsaDestinationCity.includes(' / ') ? gsaDestinationCity.split(' / ')[0] : gsaDestinationCity;
                regionName = `${gsaDestinationCity}, ${gsaDestinationState}`;
              }

              const homesalePriceResp = await props.getHomesalePriceByRegion(regionName);
              if (homesalePriceResp.response) {
                setAvgHomesalePrice(parseFloat(homesalePriceResp.response.averagePrice.replace(/[$,]+/g,"")));
              }

              // let currentDate = new Date();
              // let fullRate = gsaResp.rates[0].rate[0].months.month.find((rt) => rt.number === (currentDate.getMonth() + 1));
              setPerDiemMealRate(gsaNationalMealRate);
              setPerDiemRate(gsaNationalLodgingRate);

              if (origin && origin.city && origin.state) {
                const gsaOriginResp = await getGsaPerDiem(origin.city, origin.state, '2025');
                const gsaOriginState = gsaOriginResp.rates[0].state;
                let gsaOriginCity = gsaOriginResp.rates[0].rate[0].city;

                let originRegionName = 'United States';
                if (gsaOriginCity !== null && gsaOriginState !== null) {
                    gsaOriginCity = gsaOriginCity.includes(' / ') ? gsaOriginCity.split(' / ')[0] : gsaOriginCity;
                    originRegionName = `${gsaOriginCity}, ${gsaOriginState}`;
                }

                const homesalePriceOriginResp = await props.getHomesalePriceByRegion(originRegionName);
                if (homesalePriceOriginResp.response) {
                    setAvgHomesalePriceOrigin(parseFloat(homesalePriceOriginResp.response.averagePrice.replace(/[$,]+/g,"")));
                }

                let baseDate = new Date();
                baseDate.setDate(baseDate.getDate() + 14);
                const departureDate = baseDate.toISOString().split('T')[0];
                baseDate.setDate(baseDate.getDate() + numDaysBetweenFlights);
                const returnDate = baseDate.toISOString().split('T')[0];

                let newDistance = await getDistance(origin, destination);
                const newParsedDistance = newDistance.value ? parseFloat(newDistance.value / 1609).toFixed(2) : 0;

                const flightCostResp = await props.getFlightPrice({
                    departureCity: gsaOriginCity ? gsaOriginCity : origin.city,
                    departureState: gsaOriginState,
                    destinationCity: gsaDestinationCity ? gsaDestinationCity : destination.city,
                    destinationState: gsaDestinationState,
                    departureDate: departureDate,
                    returnDate: returnDate,
                    mileage: newParsedDistance,
                });

                if (flightCostResp.response && flightCostResp.response.price) {
                    setFlightCost(parseFloat(flightCostResp.response.price.total.replace(/[$,]+/g,"")));
                }

                setIsUpdatingSelections(false);
              } else {
                setIsUpdatingSelections(false);
              }
          }
      })();
  }, [destination, origin]);

  useEffect(() => {
      (async () => {
          if (origin && origin.formattedAddress && destination && destination.formattedAddress) {
              let newDistance = await getDistance(origin, destination);
              const newParsedDistance = newDistance.value ? parseFloat(newDistance.value / 1609).toFixed(2) : 0;
              setDistance(newParsedDistance);

              if (newParsedDistance > 0) {
                const autoShipmentResp = await props.getAutoShipmentCost(newParsedDistance);
                if (autoShipmentResp.response && autoShipmentResp.response.price) {
                    setAutoShipmentCost(parseFloat(autoShipmentResp.response.price));
                }
              }

              setBenefits(getBenefits(perDiemRate, perDiemMealRate, avgHomesalePrice, avgHomesalePriceOrigin, flightCost, homefindingDays, autoShipmentCost, distance));
          }
      })();
  }, []);

  useEffect(() => {
    setBenefits(getBenefits(perDiemRate, perDiemMealRate, avgHomesalePrice, avgHomesalePriceOrigin, flightCost, homefindingDays, autoShipmentCost, distance));
  }, [perDiemRate, avgHomesalePrice, avgHomesalePriceOrigin, flightCost, homefindingDays, autoShipmentCost]);

  useEffect(() => {
      checkIsDirty();
  }, [costEstimatePolicyId, reloPolicy, hasSpouse, accompanyingAdults, origin, destination, transfereeName, isExecutive, estimateInfo]);

  const createdDate = estimateInfo && estimateInfo.created ? new Date(estimateInfo.created) : new Date();
  const modifiedDate = estimateInfo && estimateInfo.modified ? new Date(estimateInfo.modified) : new Date();
  const formattedCreated = `${createdDate.getUTCFullYear()}-${((createdDate.getUTCMonth() + 1) <= 9) ? ('0' + (createdDate.getUTCMonth() + 1)) : createdDate.getUTCMonth() + 1}-${(createdDate.getUTCDate() <= 9) ? ('0' + createdDate.getUTCDate()) : createdDate.getUTCDate()}`;
  const formattedModified = `${modifiedDate.getUTCFullYear()}-${((modifiedDate.getUTCMonth() + 1) <= 9) ? ('0' + (modifiedDate.getUTCMonth() + 1)) : modifiedDate.getUTCMonth() + 1}-${(modifiedDate.getUTCDate() <= 9) ? ('0' + modifiedDate.getUTCDate()) : modifiedDate.getUTCDate()}`;
  const formattedLastDayToModify = estimateInfo && estimateInfo.created ? new Date(new Date(estimateInfo.created).setUTCDate(new Date(estimateInfo.created).getUTCDate() + 10)).toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
  const formattedLockedDay = estimateInfo && estimateInfo.created ? new Date(new Date(estimateInfo.created).setUTCDate(new Date(estimateInfo.created).getUTCDate() + 11)).toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
  const lastDayHasPassed = estimateInfo && estimateInfo.created ? new Date() > new Date(formattedLockedDay) : false;

  return (
      <div>
          <NavigationPrompt when={isDirty || isBenefitListDirty}> 
            {({ onConfirm, onCancel }) => {
                return (
                    <ConfirmModal
                        cancelText="Cancel"
                        confirmText="Confirm"
                        handleClose={() => { props.setBackButtonPath('/estimates'); onCancel(); }}
                        handleConfirm={onConfirm}
                        titleText="Unsaved Changes"
                        bodyText="You have unsaved changes on this cost estimate. Would you like to leave this page?"
                    />
                );
            }}
          </NavigationPrompt>

          <Box sx={{ position: 'fixed', zIndex: 4, backgroundColor: 'white', padding: '0px 0px 0px 0px', width: props.drawerOpen ? 'calc(100% - 240px)' : 'calc(100% - 60px)' }}>
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#de3f18', padding: '5px 0px 5px 5px' }}>
                <Box sx={{ color: '#ffffff', fontSize: '14px'}}>The amounts provided are estimates only. Actual cost may vary.</Box>
              </Box>
              <Box sx={{ padding: '10px 0px 10px 10px'}}>
                  <Grid container direction="row" >
                      <Grid item xs={2}>
                          <Box sx={{ paddingTop: '10px' }}>
                              <TextField
                                  id="name"
                                  className={classes.textField}
                                  label="Transferee Name"
                                  value={transfereeName}
                                  variant="outlined"
                                  size="small"
                                  onChange={(e) => setTransfereeName(e.target.value)}
                                  disabled={lastDayHasPassed}
                              />
                          </Box>
                      </Grid>
                      <Grid item xs={2}>
                          <Box sx={{ paddingTop: '10px' }}>
                              <TextField
                                  id="costEstimatePolicyId"
                                  select
                                  label="Cost Estimate Policy"
                                  className={classes.textField}
                                  onChange={(e) => changePolicy(e.target.value)}
                                  value={costEstimatePolicyId}
                                  fullWidth={true}
                                  variant="outlined"
                                  size="small"
                                  disabled={props.clientSettings ? !props.clientSettings.isPremium : true || lastDayHasPassed}
                              >
                                  {(!props.clientsSettings || (props.clientSettings && !props.clientSettings.isPremium)) && <MenuItem value={null} key={1}>N/A</MenuItem>}
                                  {props.policies && props.policies.filter((policy) => policy.isPublished === true).map((policy) => <MenuItem value={policy.policyId}>{policy.policyName}</MenuItem>)}
                              </TextField>
                          </Box>
                      </Grid>
                      <Grid item xs={2}>
                          <Box sx={{ paddingTop: '10px' }}>
                              <TextField
                                  id="reloPolicy"
                                  select
                                  label="Ownership Status"
                                  className={classes.textField}
                                  onChange={(e) => changeOwnershipType(e.target.value)}
                                  value={reloPolicy}
                                  fullWidth={true}
                                  variant="outlined"
                                  size="small"
                                  disabled={lastDayHasPassed}
                              >
                                  <MenuItem value={'Homeowner'} key={0}>Homeowner</MenuItem>
                                  <MenuItem value={'Renter'} key={1}>Renter</MenuItem>
                              </TextField>
                          </Box>
                      </Grid>
                      <Grid item xs={2}>
                          <Box sx={{ maxWidth: '200px' }}>
                              <GooglePlacesAutocompleteComponent
                                  initialValue={origin}
                                  value={origin != null ? (origin.formattedAddress ? origin.formattedAddress : origin) : ''}
                                  label={'Origin Location'}
                                  onSelect={async (event, value) => {
                                      setOrigin(value);

                                      if (value && destination && destination.length !== 0) {
                                            // Distance is returned in meters so we need to divide by 1609 to get miles.
                                            let newDistance = await getDistance(value, destination);
                                            const newParsedDistance = newDistance.value ? parseFloat(newDistance.value / 1609).toFixed(2) : 0;
                                            setDistance(newParsedDistance);

                                            if (newParsedDistance > 0) {
                                                const autoShipmentResp = await props.getAutoShipmentCost(newParsedDistance);
                                                if (autoShipmentResp.response && autoShipmentResp.response.price) {
                                                    setAutoShipmentCost(parseFloat(autoShipmentResp.response.price));
                                                }
                                            }
                                      }
                                  }}
                                  onInputEdit={async (event) => {
                                      setOrigin(event);
                                  }}
                                  onInputClear={(event) => {
                                      setOrigin('');
                                  }}
                                  // onFocus={onFocus}
                                  // onBlur={onBlur}
                                  disabled={lastDayHasPassed}
                              />
                          </Box>
                      </Grid>
                      <Grid item xs={2}>
                          <Box sx={{ maxWidth: '200px' }}>
                              <GooglePlacesAutocompleteComponent
                                  initialValue={destination}
                                  value={destination != null ? (destination.formattedAddress ?  destination.formattedAddress : destination) : ''}
                                  label={'Destination Location'}
                                  onSelect={async (event, value) => {
                                      setDestination(value);
                                      if (value && origin && origin.length !== 0) {
                                        // Distance is returned in meters so we need to divide by 1609 to get miles.
                                        let newDistance = await getDistance(origin, value);
                                        const newParsedDistance = newDistance.value ? parseFloat(newDistance.value / 1609).toFixed(2) : 0;
                                        setDistance(newParsedDistance);

                                        if (newParsedDistance > 0) {
                                            const autoShipmentResp = await props.getAutoShipmentCost(newParsedDistance);
                                            if (autoShipmentResp.response && autoShipmentResp.response.price) {
                                                setAutoShipmentCost(parseFloat(autoShipmentResp.response.price));
                                            }
                                        }
                                      }
                                  }}
                                  onInputEdit={(event) => setDestination(event)}
                                  onInputClear={(event) => {
                                      setDestination('');
                                  }}
                                  size="small"
                                  // onFocus={onFocus}
                                  // onBlur={onBlur}
                                  disabled={lastDayHasPassed}
                              />
                          </Box>
                      </Grid>
                      <Grid item xs={2}>
                          <Box sx={{ paddingTop: '5px' }}>
                              <Typography color="primary">{estimateId ? `Cost Estimate ID ${estimateId}` : 'New Cost Estimate'}</Typography>
                              <Typography color="secondary">Move Miles: {distance}</Typography>
                          </Box>
                      </Grid>
                      <Grid item xs={2}>
                          <Box sx={{ paddingTop: '10px' }}>
                              <TextField
                                  id="accompanyingAdults"
                                  className={classes.textField}
                                  label="Accompanying Family Members"
                                  value={accompanyingAdults}
                                  variant="outlined"
                                  type="number"
                                  onChange={(e) => setAccompanyingAdults(e.target.value)}
                                  size="small"
                                  disabled={lastDayHasPassed}
                              />
                          </Box>
                      </Grid>

                      <Grid item xs={2}>
                          <Box sx={{ paddingTop: '10px' }}>
                              <TextField
                                  id="dateCreated"
                                  label="Date Created"
                                  type="date"
                                  value={formattedCreated}
                                  InputLabelProps={{
                                      shrink: true,
                                  }}
                                  InputProps={{
                                      className: classes.input,
                                  }}
                                  placeholder={'yyyy-mm-dd'}
                                  className={classes.textField}
                                  disabled={true}
                                  size="small"
                              />
                          </Box>
                      </Grid>
                      <Grid item xs={2}>
                          <Box sx={{ paddingTop: '10px' }}>
                              <TextField
                                  id="lastDayToModify"
                                  label="Last Day to Modify"
                                  type="date"
                                  value={formattedLastDayToModify}
                                  InputLabelProps={{
                                      shrink: true,
                                  }}
                                  InputProps={{
                                      className: classes.input,
                                  }}
                                  placeholder={'yyyy-mm-dd'}
                                  className={classes.textField}
                                  disabled={true}
                                  size="small"
                              />
                          </Box>
                      </Grid>
                      <Grid item xs={2}>
                          <Box sx={{ paddingTop: '10px' }}>
                              <TextField
                                  id="dateModified"
                                  label="Date Modified"
                                  type="date"
                                  value={formattedModified}
                                  InputLabelProps={{
                                      shrink: true,
                                  }}
                                  InputProps={{
                                      className: classes.input,
                                  }}
                                  placeholder={'yyyy-mm-dd'}
                                  className={classes.textField}
                                  disabled={true}
                                  size="small"
                              />
                          </Box>
                      </Grid>
                  </Grid>
              </Box>
              {props.clientSettings && props.clientSettings.isPremium && (
                <Box sx={{ paddingLeft: '10px', paddingBottom: '10px' }}>
                    <Hint>Selecting one of your company policies will automatically enable that policy's benefits. You can also make changes to the cost estimate after starting from the policy.</Hint>
                </Box>
              )}
          </Box>

          <Box sx={{paddingTop: '205px', marginLeft: '10px', marginRight: '10px'}}>
              <BenefitSelections 
                isHeaderDirty={isDirty} 
                savingEstimate={savingEstimate} 
                reloPolicy={reloPolicy} 
                distance={distance} 
                estimateInfo={estimateInfo} 
                saveEstimate={saveEstimate} 
                exportEstimate={exportEstimate} 
                generateAuth={generateAuth} 
                benefits={benefits} 
                estimateId={estimateId}
                isUpdatingSelections={isUpdatingSelections}
                policyId={null}
                updatedPolicyBenefits={updatedPolicyBenefits}
                updatedGrossUp={updatedGrossUp}
                isPremium={props.clientSettings ? props.clientSettings.isPremium : false}
                freeDownloadInfo={{
                    estimateInfo: {
                        transfereeName: transfereeName,
                        reloPolicy: reloPolicy,
                        origin: origin,
                        destination: destination,
                        distance: distance,
                        accompanyingAdults: Number(accompanyingAdults),
                        topLevelInputOneId: estimateInfo ? estimateInfo.topLevelInputOneId : null,
                        topLevelInputTwoId: estimateInfo ? estimateInfo.topLevelInputTwoId : null,
                        topLevelInputThreeId: estimateInfo ? estimateInfo.topLevelInputThreeId : null,
                        topLevelInputFourId: estimateInfo ? estimateInfo.topLevelInputFourId : null,
                    },
                    distance: distance,
                    perDiemRate: perDiemRate,
                    perDiemMealRate: perDiemMealRate,
                    avgHomesalePrice: avgHomesalePrice,
                    avgHomesalePriceOrigin: avgHomesalePriceOrigin,
                    flightCost: flightCost,
                    homefindingDays: homefindingDays,
                    applyTaxGrossUp: estimateInfo ? estimateInfo.applyTaxGrossUp : false,
                    autoShipmentCost: autoShipmentCost,
                }}
                setParentBenefitListDirty={setIsBenefitListDirty}
                lastDayHasPassed={lastDayHasPassed}
              />
          </Box>

          <Dialog
              open={needsDisclaimer}
              onClose={() => { localStorage.setItem('disclaimer', 'approved'); setNeedsDisclaimer(false); }}
              maxWidth="md"
              fullWidth>
              <DialogTitle>
                  Disclaimer
              </DialogTitle>
              <DialogContent classes={{ root: classes.content }}>
                  <Box>
                      <Typography variant="subtitle1" color="secondary">
                          The costs provided are intended for estimate purposes only. Actual costs may vary and are subject to change based on the specific services performed. These estimates should not be interpreted as final.
                      </Typography>
                  </Box>
              </DialogContent>
              <DialogActions>
                  <Grid container justify="flex-end">
                      <Box sx={{padding: '12px'}}>
                          <Button variant="outlined" size="large" color="primary" onClick={() => { localStorage.setItem('disclaimer', 'approved'); setNeedsDisclaimer(false); }} disabled={false}>Confirm</Button>
                      </Box>
                  </Grid>
              </DialogActions>
          </Dialog>
      </div>
  );
}

const mapStateToProps = (state) => {
  return {
    authorizationSearchResults: state.transferees.get('authorizationSearchResults'),
    estimates: state.estimator.get('estimates'),
    policies: state.estimator.get('policies'),
    clientSettings: state.estimator.get('clientSettings'),
    drawerOpen: state.layout.get('drawerOpen'),
  };
};

export default withRouter(
  connect(mapStateToProps, {
    setPageTitle,
    showToast,
    setEstimations,
    getEstimates,
    postEstimate,
    updateEstimate,
    setBackButtonPath,
    getHomesalePriceByRegion,
    getFlightPrice,
    setBaseMoveInfo,
    getAutoShipmentCost,
  })(CostEstimatorPage),
);
